import { cn } from "@guru/shared/utils/cn";
import { Lock } from "lucide-react";
import type React from "react";

interface BrowserFrameProps {
  /** Text shown in the address pill, e.g. "app.etheraguru.com". */
  address?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Lightweight browser-window chrome for staging dashboard moments.
 */
export function BrowserFrame({
  address = "app.etheraguru.com",
  className,
  children,
}: BrowserFrameProps) {
  return (
    <div
      className={cn("overflow-hidden rounded-xl border border-border bg-card shadow-xl", className)}
    >
      <div className="flex items-center gap-2 border-b border-border bg-muted/50 px-4 py-2.5">
        <span className="flex gap-1.5" aria-hidden="true">
          <span className="h-2.5 w-2.5 rounded-full bg-destructive/60" />
          <span className="h-2.5 w-2.5 rounded-full bg-[var(--brand-orange)] opacity-60" />
          <span className="h-2.5 w-2.5 rounded-full bg-positive opacity-60" />
        </span>
        <span className="ml-2 inline-flex min-w-0 items-center gap-1.5 rounded-md bg-background px-2.5 py-0.5 text-xs text-muted-foreground">
          <Lock className="h-3 w-3 shrink-0 text-positive" aria-hidden="true" />
          <span className="truncate">{address}</span>
        </span>
      </div>
      <div>{children}</div>
    </div>
  );
}
